import React from 'react';

import { useQuery } from '@tanstack/react-query';

import Table from '../../../../Table';

import VendorService from '../../../../../services/VendorService';
import formatBorrowerName from '../../../../../helpers/formatBorrowerName';

const cols = [
  {
    title: 'Policy Number',
    keys: ['policy_number'],
    link: (row) => `/loans/${row.loan_id}/insurances/${row.id}?tab=Insurance`,
  },
  {
    title: 'Status',
    keys: ['status'],
  },
  {
    title: 'Start Date',
    keys: ['start_date'],
    type: 'date',
  },
  {
    title: 'End Date',
    keys: ['end_date'],
    type: 'date',
  },
  {
    title: 'Property',
    keys: ['_loan._property.address_line_1'],
  },
  {
    title: 'Borrower',
    keys: ['_loan._borrower_primary'],
    format: (borrower) => formatBorrowerName(borrower),
  },
];

export default function Insurances({ vendorId }) {
  const { data: insurances } = useQuery({
    queryKey: ['vendorInsurances', vendorId],
    queryFn: () => VendorService.getVendorInsurances(vendorId),
    enabled: !!vendorId,
  });

  return (
    <div className="p-7 col-span-full sm:col-span-6 xl:col-span-4 bg-white dark:bg-slate-800 shadow-lg rounded-sm border border-slate-200 dark:border-slate-700 mb-10">
      <h2 className="text-2xl text-slate-800 dark:text-slate-100 font-bold mb-6">
        Insurances
      </h2>
      <Table cols={cols} rows={insurances} title="" minHeight={565} />
    </div>
  );
}
